import type { SFSymbol } from 'sf-symbols-typescript';

import type { MainTabParamList } from './types';

export type MainTabName = keyof MainTabParamList;

/**
 * Semantic tab icon id — one meaning across platforms.
 * iOS native tabs: SF Symbol. Android native tabs: PNG in nativeTabIcon.ts.
 * JS surfaces: TabIcon (Skia native / SVG web).
 */
export type TabIconId = 'home' | 'spend' | 'wealth' | 'loan' | 'grow';

export type TabIconConfig = {
  /** iOS SF Symbol for native bottom tab bar */
  sfSymbol: SFSymbol;
  /** Shared glyph id — TabIcon Skia/SVG and Android PNG */
  web: TabIconId;
};

/** Single source of truth for tab labels and icons (all platforms). */
export const MAIN_TAB_META: Record<
  MainTabName,
  { label: string; icon: TabIconConfig }
> = {
  Home: { label: 'Home', icon: { sfSymbol: 'house.fill', web: 'home' } },
  Spend: { label: 'Spend', icon: { sfSymbol: 'creditcard.fill', web: 'spend' } },
  Wealth: {
    label: 'Wealth',
    icon: { sfSymbol: 'chart.line.uptrend.xyaxis', web: 'wealth' },
  },
  Grow: {
    label: 'Grow',
    icon: { sfSymbol: 'chart.bar.fill', web: 'grow' },
  },
  Loan: {
    label: 'Loan',
    icon: { sfSymbol: 'building.columns.fill', web: 'loan' },
  },
};

export function getTabLabel(name: string): string {
  return MAIN_TAB_META[name as MainTabName]?.label ?? name;
}

export function getTabIconConfig(name: string): TabIconConfig | undefined {
  return MAIN_TAB_META[name as MainTabName]?.icon;
}
